<template>
  <OrderForm />
</template>

<script>
import OrderForm from '../components/OrderForm.vue'

export default {
  name: 'Order',
  components: {
    OrderForm
  }
}
</script>
